import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "@/translations/it.json";
import en from "@/translations/en.json";

export const SUPPORTED_LANGS = ["it", "en"];
export const DEFAULT_LANG = "it";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
    },
    lng: DEFAULT_LANG,
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_LANGS,
    interpolation: { escapeValue: false },
    returnObjects: true,
  });

export default i18n;
